module.exports = __webpack_public_path__ + "static/media/battery-slash.2a08a49a.svg";